const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage, onItemsPerPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  // Logic from renderPagination...
  pages.push(
    <button key={1} onClick={() => onPageChange(1)} className={`pagination-button ${currentPage === 1 ? 'active' : ''}`} disabled={currentPage === 1}>1</button>
  );
  if (currentPage > 4) pages.push(<span key="ellipsis1" className="pagination-ellipsis">...</span>);
  for (let i = Math.max(2, currentPage - 2); i <= Math.min(totalPages - 1, currentPage + 2); i++) {
    pages.push(
      <button key={i} onClick={() => onPageChange(i)} className={`pagination-button ${currentPage === i ? 'active' : ''}`}>{i}</button>
    );
  }
  if (currentPage < totalPages - 3) pages.push(<span key="ellipsis2" className="pagination-ellipsis">...</span>);
  if (totalPages > 1 && currentPage !== totalPages) { // Ensure last page button is not duplicated if it's already in the loop
     if (!pages.find(p => p.key === totalPages.toString())) {
        pages.push(
            <button key={totalPages} onClick={() => onPageChange(totalPages)} className={`pagination-button ${currentPage === totalPages ? 'active' : ''}`} disabled={currentPage === totalPages}>{totalPages}</button>
        );
     }
  }


  return (
    <div className="pagination-container">
      <button className="pagination-button pagination-nav" onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>
        <i className='bx bx-chevron-left'></i>
      </button>
      {pages}
      <button className="pagination-button pagination-nav" onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages}>
        <i className='bx bx-chevron-right'></i>
      </button>
      <div className="pagination-info">Page {currentPage} of {totalPages || 1}</div>
      <select className="items-per-page-select" value={itemsPerPage} onChange={(e) => onItemsPerPageChange(Number(e.target.value))}>
        <option value={10}>10 per page</option>
        <option value={25}>25 per page</option>
        <option value={50}>50 per page</option>
        <option value={100}>100 per page</option>
      </select>
    </div>
  );
};

export default Pagination;